import React, { useRef, useEffect } from 'react'
import styles from './Comment.module.scss'

interface Props {
  text: string
}

const Comment = ({ text }:Props) => {
  const el = useRef<HTMLSpanElement>(null)

  useEffect(() => {
    if (!el || !el.current) {
      return
    }

    const comment = document.createComment(text)

    const parent = el.current.parentElement!

    parent.insertBefore(comment, el.current)
  }, [text])

  return <span ref={el}  className={styles.comment}/>
}

export default Comment